import classnames from 'classnames';
import React, { FC, useMemo } from 'react';
import { getFileExtension } from '../../../../../../utils/media-manager-sdk/items';
import {
  isFailed as isFileFailed,
  isReady as isFileReady,
  isTranscoding as isFileTranscoding,
} from '../../../../../../utils/media-manager-sdk/transcoding';
import { parseFileName } from '../../../../../../utils/path';
import { ErrorOverlay, TranscodingOverlay } from '../../../../TranscodingOverlays';
import { FileLabeledThumbnail } from '../../../FileLabeledThumbnail';
import { IFileThumbnail } from '../../../types';
import styles from '../../FileThumbnail.scss';

export const MusicThumbnail: FC<IFileThumbnail> = ({
  file,
  className,
  width,
  height,
  dataHook = 'music-file-thumbnail',
  labelClassName,
  thumbnailSize,
  saveRef,
  wrapperStyle,
  wrapperClassName,
}) => {
  const { isTranscoding, isFailed, isReady } = useMemo(
    () => ({
      isTranscoding: isFileTranscoding(file),
      isFailed: isFileFailed(file),
      isReady: isFileReady(file),
    }),
    [file],
  );

  return (
    <div
      className={classnames(
        styles.thumbnailWrapper,
        {
          [styles.thumbnailWrapperTranscoding]: isTranscoding,
          [styles.thumbnailWrapperError]: isFailed,
          [styles.thumbnailWrapperReady]: isReady,
        },
        wrapperClassName,
      )}
      ref={saveRef}
    >
      <FileLabeledThumbnail
        className={classnames(styles.thumbnail, styles.music, styles[thumbnailSize], className)}
        label={isReady && `.${getFileExtension(file) || parseFileName(file.name).extension}`}
        width={width}
        height={height}
        labelClassName={labelClassName}
        dataHook={dataHook}
        style={wrapperStyle}
      />

      {isTranscoding && <TranscodingOverlay />}
      {isFailed && <ErrorOverlay />}
    </div>
  );
};
